import { LoadTagsReturnType } from '~src/services/api/archiveSettings';
import { DB_STATE } from '~src/types/enums';

export const getTagsForFile = (
  tagsArray: number[] | string[] | undefined | null,
  tagsData: LoadTagsReturnType | undefined
): (string | number | null)[] | null => {
  if (!tagsArray || !tagsData) {
    return null;
  }

  const result = (tagsArray as Array<number | string>)
    .map((tagId) => {
      const tagData = tagsData.find((tag) => tag.id === Number(tagId));
      return tagData ? tagData.title : null;
    })
    .filter((tagName) => tagName !== null);

  return result.length > 0 ? result : null;
};
